export default __webpack_public_path__ + "static/media/MadMenofBombay.f67de3d9.png";